/* ============================================================================
   MoveOn™ Listicle landing page — interactions
   ----------------------------------------------------------------------------
   Vanilla port of the Claude Design comp's `Component extends DCLogic` class
   (project ad05f006-36ce-435b-8777-8f74d1a60391). No framework, no support.js.
   Drives:
     • hero carousel   (6 slides, auto-advance, dot controls, reset-on-pick)
     • offer gallery   (cross-fade + thumbnails)
     • bundle + plan   (live pricing across CTA, cart drawer and sticky bar)
     • cart drawer     (slide-in summary, Esc / scrim to close)
     • FAQ + ingredient accordions (single-open)
     • review wall     (3 columns auto-scrolling at different speeds)
     • generations chart (bars grow when the block scrolls in)
     • sticky add-to-cart bar (reveals past 620px)
     • all [data-pro] videos (force muted + looping, never unmutable)
   ============================================================================ */
(function () {
  'use strict';

  var AUTOPLAY_MS = 4000;      // comp prop: autoplaySeconds = 4
  var SHOW_STICKY = true;      // comp prop: showStickyBar = true
  var DEFAULT_PLAN = 'sub';    // comp prop: defaultPlan = 'sub'

  // Bundle table, verbatim from the comp. variant/plan are the live Shopify ids for
  // Moveon™ (product 9292633047281); `plan` is the Subscribe & Save selling plan,
  // and its price matches this table exactly ($79 / $130 / $177).
  var BUNDLES = [
    { t: '1 Box',   was: 107, price: 87,  sub: 79,  extra: 9,  variant: 46917573771505, plan: 5251432689 },
    { t: '2 Boxes', was: 214, price: 146, sub: 130, extra: 11, variant: 46917573804273, plan: 5251465457 },
    { t: '3 Boxes', was: 319, price: 199, sub: 177, extra: 11, variant: 46917573837041, plan: 5251498225 }
  ];

  var state = { slide: 0, gal: 0, bundle: 1, plan: DEFAULT_PLAN, bar: false, cartOpen: false };

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function fmt(n) { return '$' + (Number.isInteger(n) ? String(n) : n.toFixed(2)); }
  function setText(sel, txt) { $$(sel).forEach(function (el) { el.textContent = txt; }); }

  /* ---------------------------------------------------------------- hero -- */
  var heroTrack = $('[data-hero-track]');
  var heroDots = $$('[data-hero-dot]');
  var heroCount = heroTrack ? heroTrack.children.length : 0;
  var heroTimer = null;

  function renderHero() {
    if (!heroTrack) return;
    heroTrack.style.transform = 'translateX(-' + (state.slide * 100) + '%)';
    heroDots.forEach(function (d, i) { d.classList.toggle('is-active', i === state.slide); });
  }

  function startHeroTimer() {
    if (heroTimer) clearInterval(heroTimer);
    if (!heroCount || reduceMotion) return;
    heroTimer = setInterval(function () {
      state.slide = (state.slide + 1) % heroCount;
      renderHero();
    }, AUTOPLAY_MS);
  }

  heroDots.forEach(function (dot, i) {
    dot.addEventListener('click', function () {
      state.slide = i;
      renderHero();
      startHeroTimer();          // picking a dot restarts the clock, as in the comp
    });
  });

  /* ------------------------------------------------------------- gallery -- */
  var galSlides = $$('[data-gal-slide]');
  var galThumbs = $$('[data-gal-thumb]');

  function renderGallery() {
    galSlides.forEach(function (img, i) { img.classList.toggle('is-active', i === state.gal); });
    galThumbs.forEach(function (b, i) {
      b.classList.toggle('is-active', i === state.gal);
      b.setAttribute('aria-current', i === state.gal ? 'true' : 'false');
    });
  }

  galThumbs.forEach(function (btn, i) {
    btn.addEventListener('click', function () { state.gal = i; renderGallery(); });
  });

  /* ------------------------------------------------- bundle / plan / cart -- */
  var offerRoot = $('[data-offer]');
  var bundleBtns = $$('[data-bundle]');
  var planBtns = $$('[data-plan]');
  var subFrame = $('[data-sub-frame]');
  var subBenefits = $('[data-sub-benefits]');
  var cart = $('[data-cart]');

  function renderPricing() {
    var B = BUNDLES[state.bundle];
    var isSub = state.plan === 'sub';
    var now = isSub ? B.sub : B.price;

    if (offerRoot) offerRoot.classList.toggle('is-sub', isSub);

    bundleBtns.forEach(function (btn, i) {
      var b = BUNDLES[i];
      var bnow = isSub ? b.sub : b.price;
      btn.classList.toggle('is-selected', i === state.bundle);
      btn.setAttribute('aria-pressed', i === state.bundle ? 'true' : 'false');
      var was = $('[data-b-was]', btn);
      var nowEl = $('[data-b-now]', btn);
      var save = $('[data-b-save]', btn);
      if (was) was.textContent = fmt(b.price);
      if (nowEl) nowEl.textContent = fmt(bnow);
      if (save) save.textContent = 'Save ' + fmt((isSub ? b.price : b.was) - bnow);
    });

    planBtns.forEach(function (btn) {
      var on = btn.getAttribute('data-plan') === state.plan;
      btn.classList.toggle('is-selected', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    if (subFrame) subFrame.classList.toggle('is-on', isSub);
    if (subBenefits) subBenefits.hidden = !isSub;

    setText('[data-sub-save]', 'Extra ' + B.extra + '% off');
    setText('[data-sub-extra]', 'Extra ' + B.extra + '% off (save ' + fmt(B.price - B.sub) + ')');
    setText('[data-sub-perbox]', fmt(B.sub / (state.bundle + 1)) + ' each box');
    setText('[data-sub-price]', fmt(B.sub));
    setText('[data-once-price]', fmt(B.price));
    setText('[data-cta-price]', fmt(now));
    setText('[data-bar-bundle]', B.t);

    // cart drawer summary
    setText('[data-cart-bundle]', 'MoveOn™ · ' + B.t);
    setText('[data-cart-serv]', ((state.bundle + 1) * 16) + ' sachets · 25 ml each');
    setText('[data-cart-plan]', isSub ? 'Subscribe & Save · pause or cancel anytime' : 'One-time purchase');
    setText('[data-cart-now]', fmt(now));
    setText('[data-cart-was]', fmt(B.price));
    $$('[data-cart-was]').forEach(function (el) { el.hidden = !isSub; });
    var cartImg = $('[data-cart-img]');
    if (cartImg) cartImg.style.backgroundImage = 'url(' + BUNDLES[state.bundle].img + ')';
  }

  bundleBtns.forEach(function (btn, i) {
    BUNDLES[i].img = btn.getAttribute('data-bundle-img') || '';
    btn.addEventListener('click', function () { state.bundle = i; renderPricing(); });
  });

  planBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.plan = btn.getAttribute('data-plan');
      renderPricing();
    });
  });

  function setCart(open) {
    state.cartOpen = open;
    if (!cart) return;
    cart.classList.toggle('is-open', open);
    cart.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.documentElement.style.overflow = open ? 'hidden' : '';
    if (open) {
      var close = $('[data-cart-close]', cart);
      if (close) close.focus();
    }
  }

  /* Add the selected bundle straight to the real Shopify cart, then show the
     drawer. The cart is cleared first so it always holds exactly what the page is
     showing: this is a single-product funnel and the drawer renders one line.
     Off Shopify (or if the call fails) we fall back to scrolling to the offer,
     so the button is never a dead end. */
  function addToCart(btn) {
    var B = BUNDLES[state.bundle];
    var item = { id: B.variant, quantity: 1 };
    if (state.plan === 'sub' && B.plan) item.selling_plan = B.plan;

    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.dataset.label = btn.textContent; btn.textContent = 'Adding…'; }
    var post = function (url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body || {})
      });
    };

    return post('/cart/clear.js')
      .then(function () { return post('/cart/add.js', { items: [item] }); })
      .then(function (res) { if (!res.ok) throw new Error('add failed ' + res.status); return res.json(); })
      .then(function () {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        setCart(true);
      })
      .catch(function () {
        var offer = document.getElementById('offer');
        if (offer) offer.scrollIntoView({ behavior: 'smooth', block: 'start' });
      })
      .then(function () {
        if (btn) { btn.removeAttribute('aria-busy'); btn.textContent = btn.dataset.label || 'Get MoveOn'; }
      });
  }

  $$('[data-add-to-cart]').forEach(function (b) {
    b.addEventListener('click', function () { addToCart(b); });
  });
  $$('[data-cart-open]').forEach(function (b) { b.addEventListener('click', function () { setCart(true); }); });
  $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', function () { setCart(false); }); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && state.cartOpen) setCart(false);
  });

  /* ---------------------------------------------------------- accordions -- */
  // Single-open per group, matching the comp (faqOpen defaults to item 0,
  // the offer's ingredient accordion defaults to closed).
  $$('[data-acc]').forEach(function (group) {
    var items = $$('.mo-acc-item', group);
    items.forEach(function (item) {
      var btn = $('.mo-acc-btn', item);
      var panel = $('.mo-acc-panel', item);
      var sym = $('.mo-acc-sym', item);
      if (!btn || !panel) return;
      btn.addEventListener('click', function () {
        var willOpen = !panel.classList.contains('is-open');
        items.forEach(function (other) {
          var p = $('.mo-acc-panel', other);
          var b = $('.mo-acc-btn', other);
          var s = $('.mo-acc-sym', other);
          if (p) p.classList.remove('is-open');
          if (b) b.setAttribute('aria-expanded', 'false');
          if (s) s.textContent = '+';
        });
        if (willOpen) {
          panel.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          if (sym) sym.textContent = '−';
        }
      });
    });
  });

  /* --------------------------------------------------------- sticky bar -- */
  var stickyBar = $('[data-sticky-bar]');

  function onScroll() {
    var show = window.scrollY > 620;
    if (show === state.bar) return;
    state.bar = show;
    if (stickyBar) stickyBar.classList.toggle('is-up', show && SHOW_STICKY);
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  /* -------------------------------------------------------------- video -- */
  // Every [data-pro] clip stays muted and looping, and can never be unmuted.
  // Only the clips actually on screen are told to play: there are 16 of them, and
  // asking a browser to run 16 concurrent streams (worse inside an embedded
  // preview iframe, e.g. the Shopify theme editor) is what makes them sit frozen
  // on the poster frame. The observer keeps 2-3 playing at a time instead.
  var vids = $$('video[data-pro]');
  var onScreen = new WeakSet();

  // Save-Data / slow connection: never pull video, the poster frames carry the section.
  var conn = navigator.connection || {};
  var lowData = !!conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '');

  function tryPlay(v) {
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  // src lives in data-src, so a clip costs nothing until it is actually reached.
  // Five 480p clips is still ~11 MB, which has no business downloading during a
  // page load nobody has scrolled yet.
  function ensureSrc(v) {
    if (v.dataset.src && !v.src) {
      v.preload = 'auto';
      v.src = v.dataset.src;
    }
  }

  function forceMute() {
    vids.forEach(function (v) {
      v.muted = true; v.defaultMuted = true; v.volume = 0; v.loop = true;
      if (v.paused && onScreen.has(v) && v.src) tryPlay(v);
    });
  }

  if ('IntersectionObserver' in window && !lowData) {
    var vObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          onScreen.add(v);
          ensureSrc(v);
          v.muted = true; v.loop = true;
          tryPlay(v);
        } else {
          onScreen.delete(v);
          if (!v.paused) v.pause();
        }
      });
    }, { rootMargin: '100px 0px', threshold: 0.01 });
    // wait for load so video never competes with the content people came for
    var startObserving = function () { vids.forEach(function (v) { vObs.observe(v); }); };
    if (document.readyState === 'complete') setTimeout(startObserving, 300);
    else window.addEventListener('load', function () { setTimeout(startObserving, 300); });
  } else if (!lowData) {
    vids.forEach(function (v) { onScreen.add(v); ensureSrc(v); });
  }

  forceMute();
  document.addEventListener('volumechange', forceMute, true);
  document.addEventListener('pause', forceMute, true);
  setInterval(forceMute, 3000);
  // an embedded preview can start hidden; re-assert when it becomes visible
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) forceMute();
  });

  /* -------------------------------------------------------- review wall -- */
  function startReviewWall() {
    var cols = $$('.mo-vcol');
    if (!cols.length || reduceMotion) return;
    var wall = $('.mo-vwall');
    var paused = false;
    var holdTimer = null;

    function hold() { paused = true; if (holdTimer) clearTimeout(holdTimer); }
    function release(ms) {
      if (holdTimer) clearTimeout(holdTimer);
      holdTimer = setTimeout(function () { paused = false; }, ms);
    }

    if (wall) {
      wall.addEventListener('pointerenter', hold);
      wall.addEventListener('pointerleave', function () { release(200); });
      wall.addEventListener('touchstart', hold, { passive: true });
      wall.addEventListener('touchend', function () { release(2500); }, { passive: true });
      wall.addEventListener('wheel', function () { hold(); release(2000); }, { passive: true });
    }

    var pos = cols.map(function (c) { return c.scrollTop; });
    cols.forEach(function (c, i) {
      c.addEventListener('scroll', function () {
        // adopt the user's position when they drag a column themselves
        if (paused || Math.abs(c.scrollTop - Math.round(pos[i])) > 2) pos[i] = c.scrollTop;
      }, { passive: true });
    });

    var last = performance.now();
    (function step(now) {
      var dt = Math.min((now - last) / 1000, 0.08);
      last = now;
      if (!paused) {
        cols.forEach(function (c, i) {
          var half = c.scrollHeight / 2;   // each track holds the cards twice
          if (half < 40) return;
          var track = c.firstElementChild;
          var speed = Number(track && track.dataset.speed) || 20;
          var p = pos[i] + speed * dt;
          if (p >= half) p -= half;
          pos[i] = p;
          c.scrollTop = Math.round(p);
        });
      }
      requestAnimationFrame(step);
    })(last);
  }

  /* ------------------------------------------------------------- chart --- */
  function startChartReveal() {
    var chart = $('.mo-chart');
    if (!chart) return;
    if (!('IntersectionObserver' in window)) { chart.classList.add('is-in'); return; }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.35 });
    obs.observe(chart);
  }

  /* --------------------------------------------------------------- init -- */
  renderHero();
  startHeroTimer();
  renderGallery();
  renderPricing();
  onScroll();
  startReviewWall();
  startChartReveal();
})();
